import { render, staticRenderFns } from "./GoingLiveConfirm.vue?vue&type=template&id=063a3ac2&scoped=true&"
import script from "./GoingLiveConfirm.vue?vue&type=script&lang=ts&"
export * from "./GoingLiveConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./GoingLiveConfirm.vue?vue&type=style&index=0&id=063a3ac2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063a3ac2",
  null
  
)

export default component.exports